import React from 'react';
import { Helmet } from 'react-helmet-async';
import appConfig from '../config/appConfig';

const DEFAULT_IMAGE = 'https://res.cloudinary.com/dfg39dktd/image/upload/v1779350478/car-booking/branding/og-image.jpg';

/**
 * Per-page SEO: sets a unique <title>, description, canonical and social tags.
 * Drop <SEO title="..." description="..." /> at the top of any public page.
 *
 * Props:
 *  - title:       page title (appended with the app name)
 *  - description: meta description for search snippets & social
 *  - image:       absolute image URL for social previews (optional)
 *  - path:        canonical path override, e.g. "/browse" (defaults to current URL)
 *  - noTitleSuffix: set true to use `title` exactly as given
 */
const SEO = ({ title, description, image, path, noTitleSuffix = false }) => {
  const fullTitle = title
    ? (noTitleSuffix ? title : `${title} | ${appConfig.name}`)
    : appConfig.fullName;
  const desc = description || appConfig.description;
  const ogImage = image || DEFAULT_IMAGE;

  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://wheels4rent.in';
  const pathname = typeof window !== 'undefined' ? window.location.pathname : (path || '/');
  const canonical = `${origin}${path || pathname}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={appConfig.name} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
